/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetMeetingQueryResult } from '../../models/get-meeting-query-result';

export interface ApiMeetingsGetMeetingGet$Plain$Params {
  Id?: string;
}

export function apiMeetingsGetMeetingGet$Plain(http: HttpClient, rootUrl: string, params?: ApiMeetingsGetMeetingGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMeetingQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiMeetingsGetMeetingGet$Plain.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMeetingQueryResult>;
    })
  );
}

apiMeetingsGetMeetingGet$Plain.PATH = '/api/Meetings/GetMeeting';
